import React, { useState } from 'react';

// Định nghĩa kiểu cho prop 'items'
interface RadioGroupComponentProps {
    items: { label: string, value: string }[], // Danh sách các item với label và value
    onSelect: (value: string) => void, // Hàm gọi khi người dùng chọn một option,
    className?: string
}

const RadioGroupComponent: React.FC<RadioGroupComponentProps> = ({ items, onSelect, className = '' }) => {
    const [selectedValue, setSelectedValue] = useState<string>(items[0].value) || '';

    // Hàm xử lý khi người dùng thay đổi lựa chọn
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setSelectedValue(newValue);
        onSelect(newValue); // Gọi hàm onSelect từ props
    };

    return (
        <div className={className}>
            {items.map(item => (
                <div key={item.value}>
                    <label className=' mb-2 text-[15px] text-colorTxtDetailItem font-light flex items-center'>
                        <input
                            type='radio'
                            name={item.label}
                            value={item.value}
                            checked={selectedValue === item.value}
                            onChange={handleChange}
                            className='mr-2 custom-radio'
                        />
                        {item.label}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default RadioGroupComponent;
